module.exports = __webpack_public_path__ + "img/piggy-bank.ace383cd.svg";